export default {
  allHolidays: [],
}
